import {ReduceStore} from 'flux/utils';
import Dispatcher from '../dispatcher';
import ACTION_TYPES from '../constants/action_types';
import { FilterActions } from '../constants/filter/filter_actions';

class CatalogFilterViewStoreClass extends ReduceStore {
    getInitialState() {
        return { sectionVisibility: '' };
    }

    reduce(state, {source, action}) {
        if (source === ACTION_TYPES.CATALOG_FILTER_LIGHTBOX_VIEW_ACTION) {
            switch (action.type) {
                case FilterActions.OPEN_LIGHTBOX_FILTER_SECTION:
                    if (state.sectionVisibility !== action.payload) {
                        state.sectionVisibility = action.payload;
                        this.__emitChange();
                    }

                    break;
                case FilterActions.CLOSE_LIGHTBOX_FILTER_SECTION:
                    if (state.sectionVisibility !== '') {
                        state.sectionVisibility = '';
                        this.__emitChange();
                    }

                    break;
            }
        }

        return state;
    }
}

const CatalogFilterViewStore = new CatalogFilterViewStoreClass(Dispatcher);
export default CatalogFilterViewStore;